exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#add-sub-category {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  #add-sub-category mat-form-field {\n    width: -webkit-fill-available;\n    width: -moz-available;\n    width: stretch; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/walk-call/walk-call-body/add-subcategory/addSubCategory.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/solutionForm/walk-call/walk-call-body/add-subcategory/addSubCategory.component.scss
// module chunks = main